import handler from '../handler/handler';
import messages from '../handler/messages/messages';

const statusHandler = handler(messages);

export default {
  actions: {
    updateNotice: async ({ commit, getters }, data) => {
      const notice = {
        id: data.id,
        title: data.title,
        contentUrl: data.contentUrl,
        beginAt: data.beginAt,
        isPublished: data.isPublished,
        isDeleted: data.isDeleted,
        tag: data.tag,
        tagBgColor: data.tagBgColor,
        summary: data.summary,
      };

      const result = await statusHandler.authPut({ commit, getters }, `/api/notices/${notice.id}`, notice);
      return result;
    },

    createEmptyNotice: async ({ commit, getters }) => {
      const result = await statusHandler.authPost({ commit, getters }, '/api/notices/');
      return result;
    },

    deleteNotice: async ({ commit, getters }, id) => {
      const result = await statusHandler.authDelete({ commit, getters }, `/api/notices/${id}`);
      return result;
    },

    deleteNotices: async ({ commit, getters }, ids) => {
      const result = await statusHandler.authPatch({ commit, getters }, '/api/notices/delete', ids);
      return result;
    },
  },
};



// WEBPACK FOOTER //
// ./src/vuex/modules/notice.js